import React from "react";
import { HelpCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export default function TourReplayButton({ onClick }) {
  const { t } = useTranslation("tours");
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid="tour-replay-button"
      title={t("replay_button_label")}
      aria-label={t("replay_button_label")}
      className="inline-flex items-center justify-center w-8 h-8 rounded-full border border-zinc-200 bg-white text-zinc-500 hover:text-zinc-900 hover:border-zinc-400 transition-colors shrink-0"
    >
      <HelpCircle size={15} strokeWidth={1.75} />
    </button>
  );
}
